import { createSelector } from '@ngrx/store'
import { selectAccountState } from '../../account.root.state'

export interface ManageSubscriptionState {
  data: UserData
  customFields: CustomFieldValue[]
  controls: Controls
  status: StateStatus
}

export interface UserData {
  contactId: string
  name: string
  origin: string
  timeZone: string
  activities: string
  changedOn: string
  createdOn: string
  campaign: Capaign
  email: string
  dayOfCycle: string
  scoring: number
  engagementScore: number
  href: string
  note: string
  ipAddress: string
  customFieldValues: CustomFieldValue[]
}

export interface Capaign {
  campaignId: string
  href: string
  name: string
}

export interface CustomFieldValue {
  customFieldId: string
  name: string
  value: string[]
  values: string[]
  type: string
  fieldType: string
  valueType: string
}

export interface Controls {
  isOpen: boolean[]
  isSelected: SelectNewsOrThemen[]
  disableDoi: boolean
  shouldShowUwg7: boolean
  isUnsubscribed: boolean
}

export interface SelectNewsOrThemen extends SelectionControl {
  themenSelected: SelectionControl[]
}

export interface SelectionControl {
  id: string
  isSelected: boolean
}

export interface StateStatus {
  loading: boolean
  error: boolean
  errorMessage?: string
}

export const selectManageSubscription = createSelector(selectAccountState, state => state.manageSubscriptionState)
export const selectUserData = createSelector(selectManageSubscription, state => state.data)
export const selectCustomFields = createSelector(selectManageSubscription, state => state.customFields)
export const selectStatus = createSelector(selectManageSubscription, state => state.status)
export const selectControls = createSelector(selectManageSubscription, state => state.controls)
